import { createGtag } from 'vue-gtag';

// Not to be included in the plugins index, installed at the module level
export default {
  install(app, options) {
    app.use(createGtag(options));
  },
};
